// Product data repository display constants. Values mirror the backend registries
// (backend/lib/capitalGood/productDocument.constants.js and factorSource.constants.js);
// keep them in step.

/** Typed product document kinds. EPDs are deliberately absent: they go through the structured EPD flow. */
export const PRODUCT_DOCUMENT_TYPE_OPTIONS: { value: string, label: string }[] = [
  { value: 'lca_report', label: 'LCA report' },
  { value: 'certificate', label: 'Certificate' },
  { value: 'test_report', label: 'Test report' },
  { value: 'other', label: 'Other document' },
]

export const PRODUCT_DOCUMENT_TYPE_LABELS: Record<string, string> = PRODUCT_DOCUMENT_TYPE_OPTIONS
  .reduce((labels, option) => ({ ...labels, [option.value]: option.label }), {})

/** Display names for a product factor's provenance. */
export const FACTOR_SOURCE_LABELS: Record<string, string> = {
  supplier_epd: 'Supplier EPD',
  supplier_epd_provisional: 'Supplier EPD (provisional)',
  supplier_response: 'Supplier response',
  library_eeio: 'EEIO library factor',
  library_defra: 'DEFRA library factor',
  manual: 'Manually entered',
  import: 'Imported',
}

export const factorSourceLabel = (factorSource: string | null | undefined): string => {
  if (!factorSource) return 'Not recorded'
  return FACTOR_SOURCE_LABELS[factorSource] || factorSource
}

/** Life-cycle stage figure fields (EN 15804 module groups), in display order. */
export const STAGE_FIGURE_FIELDS: { field: 'stageA1A3' | 'stageA4' | 'stageA5' | 'stageB' | 'stageC' | 'stageD', label: string }[] = [
  { field: 'stageA1A3', label: 'A1-A3 Product stage' },
  { field: 'stageA4', label: 'A4 Transport to site' },
  { field: 'stageA5', label: 'A5 Installation' },
  { field: 'stageB', label: 'B Use stage' },
  { field: 'stageC', label: 'C End of life' },
  { field: 'stageD', label: 'D Beyond the system boundary' },
]
